import { Flex, Spin } from "@murm/ant";
import { useAuth } from "../../hooks/useAuth";
import { Navigate } from "react-router-dom";
import styles from "./FullScreen.module.css";

const SecureRoute = ({ children }) => {
  const { isAuthenticated, isLoading, error } = useAuth();

  if (error) {
    return <Navigate to="/login?authError=1" replace />;
  }

  if (isLoading) {
    return (
      <Flex align="center" justify="center" className={styles.fullScreen}>
        <Spin size="large" tip="Loading…" />
      </Flex>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default SecureRoute;
